import { kleosPromiseClient } from '~/services/kleos-client';

export const getKleosDevice = async ({ deviceName }: { deviceName: string }) =>
  await kleosPromiseClient.getDevice({ name: deviceName });
